import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";

export function Navbar() {
    const [language, setLanguage] = useState("EN");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const { i18n, t } = useTranslation();
    const dropdownRef = useRef(null);  // Create a reference for the dropdown

    const languages = [
        { code: "en", name: "EN", flag: "us" },
        { code: "fr", name: "FR", flag: "fr" },
        { code: "da", name: "DA", flag: "dk" },
        { code: "ar", name: "AR", flag: "sa" },
        { code: "es", name: "SP", flag: "es" },
    ];

    const handleLanguageChange = (langCode, langName) => {
        i18n.changeLanguage(langCode);
        setLanguage(langName.toUpperCase());
        setIsDropdownOpen(false);  // Close the dropdown after selecting a language
    };

    const toggleDropdown = () => {
        setIsDropdownOpen((prevState) => !prevState);
    };

    // Close the dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div>
            <Helmet>
                <meta name="description" content={t("meta.description")} />
                <meta name="keywords" content={t("meta.keywords")} />
                <meta name="author" content={t("meta.author")} />
            </Helmet>
            <nav>
                <div className="mx-auto max-w-full px-2 sm:px-6 lg:px-8">
                    <div className="relative flex h-16 items-center justify-end">
                        <div className="flex justify-left space-x-4">
                            <a
                                href="https://calendly.com/wasifshehzad063/30min?month=2024-09"
                                target="_blank"
                                className="schedule-btn border-2 border-[#5ecaf4] text-end rounded-md px-4 py-2 text-md font-medium text-white hover:text- transition-all duration-300 ease-in-out"
                                aria-current="page"
                            >
                                {t("Navbar.schedule")}
                            </a>
                        </div>
                        <div className="flex justify-center items-center gap-2 relative">
                            <button
                                onClick={toggleDropdown}
                                className="flex items-center gap-2 px-4 py-2 text-white font-medium rounded-md transition-all"
                            >
                                <img
                                    src={`https://flagcdn.com/w40/${languages.find(lang => lang.name.toUpperCase() === language)?.flag}.png`}
                                    alt={`${language} flag`}
                                    width={20}
                                    height={20}
                                />
                                {language}
                            </button>

                            {isDropdownOpen && (
                                <div
                                    ref={dropdownRef} // Attach the ref to the dropdown
                                    className="absolute top-full mt-2 right-0 bg-white text-black shadow-md rounded-md w-fit z-10"
                                >
                                    {languages.map(({ code, name, flag }) => (
                                        <button
                                            key={code}
                                            onClick={() => handleLanguageChange(code, name)}
                                            className="flex items-center gap-2 px-4 py-2 w-fit text-left rounded-md hover:bg-gray-200"
                                        >
                                            <img
                                                src={`https://flagcdn.com/w40/${flag}.png`}
                                                alt={`${name} flag`}
                                                width={20}
                                                height={20}
                                            />
                                            {name}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                        <style>
                            {`
                .schedule-btn {
                    transition: all 0.6s ease-in-out;
                }
                .schedule-btn:hover {
                    transform: scale(1.09); 
                }
                `}
                        </style>
                    </div>
                </div>
            </nav>
        </div>
    );
}
